// extracted by mini-css-extract-plugin
export default {"tab":"zD8Mf","active":"VdxHL","inactive":"X2E4J"};